import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-036dfb8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = { class: "home-icon-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chevron" }, [
  /*#__PURE__*/_createElementVNode("span", null, ">")
], -1))
const _hoisted_4 = { class: "links-popup-container" }
const _hoisted_5 = {
  key: 0,
  class: "breadcrumb-button-text"
}
const _hoisted_6 = {
  key: 1,
  class: "breadcrumb-button-text"
}
const _hoisted_7 = {
  id: "links-popup",
  class: "links-popup"
}

import CustomRouterLink from '@/components/CustomRouterLink.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useRoute } from 'vue-router'
import { ref } from 'vue'
import { scrollToTop } from '@/helpers/helpers'
import linksInternal from '@/assets/linksInternal.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {

const showPopup = ref(false)

const togglePopup = () => {
  showPopup.value = !showPopup.value
}
const hidePopup = () => {
  showPopup.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CustomRouterLink, {
        type: "header",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-house-chimney" })
        ]),
        _: 1
      })
    ]),
    _hoisted_3,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "breadcrumb-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (togglePopup()))
      }, [
        (_unref(useRoute)().name !== 'home')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(useRoute)().name), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, " _____ "))
      ]),
      (showPopup.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "links-popup-wrapper",
            ref: "linksPopup",
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (hidePopup()))
          }, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linksInternal), (link) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  class: "links-popup-link",
                  key: link.text,
                  to: link.page,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(scrollToTop)(); hidePopup()})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(link.text.toLowerCase()), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ], 544))
        : _createCommentVNode("", true)
    ])), [
      [_directive_click_outside, hidePopup]
    ])
  ]))
}
}

})